import * as Factory from 'factory.ts'
import faker from 'faker'

import { type StripeAccountFundHistoryRecord } from '../../models'
import { StripeFundingStatus } from '../../models/enums/FundingStatus'

export const StripeAccountFundMock =
  Factory.Sync.makeFactory<StripeAccountFundHistoryRecord>({
    uuid: Factory.each(() => faker.random.uuid()),
    status: Factory.each(() =>
      faker.random.arrayElement(Object.values(StripeFundingStatus))
    ),
    amount: Factory.each(() => faker.finance.amount()),
    amount_refunded: 0,
    balance_transaction: faker.random.uuid(),
    captured: faker.random.boolean(),
    currency: 'USD',
    customer: faker.random.uuid(),
    description: faker.lorem.sentence(),
    dispute: faker.lorem.word(),
    failure_code: null,
    failure_message: null,
    fraud_details: {},
    on_behalf_of: faker.random.uuid(),
    livemode: false,
    metadata: {},
    stripe_obj_id: faker.random.uuid(),
    stripe_obj_created: faker.date.past(10),
    stripe_account_id: faker.random.uuid(),
    created_at: faker.date.past(10),
    updated_at: faker.date.past(10),
  })
